const fdicBankProductInvestmentStrategy = (
  <>
    <p>
    TIAA Retirement Reserves is a demand deposit account with the Retirement Reserves Bank,
    currently EverBank, N.A. and is only available as an investment option within your TIAA IRA.
    Please refer to the TIAA Retirement Reserves Terms and Conditions for additional information.
    </p>
    <p>
    In assessing the extent of FDIC insurance coverage for your balance in TIAA Retirement Reserves,
    which is generally limited to $250,000, such balance will be combined with other deposits you may
    have with the Retirement Reserves Bank, currently EverBank, N.A. in the same FDIC ownership category,
    which may occur through TIAA Retirement Reserves balances related to other TIAA individual retirement
    accounts (IRAs), IRA balances in the TIAA Cash Deposit Account, the TIAA Brokerage Sweep associated with
    retirement-related TIAA brokerage accounts, or through IRAs offered directly by the Retirement Reserves
    Bank. Please visit{' '}
      <a href="https://www.fdic.gov/deposit/deposits/" target="_blank\">
        www.fdic.gov/deposit/deposits/
      </a>{' '}
      for additional information regarding FDIC insurance coverage.
    </p>
  </>
);
export default fdicBankProductInvestmentStrategy;
